export const LOGINUSER = "LOGINUSER";
export const GET_DOCTORS = "GET_DOCTORS";
export const GET_OPTICIANS = "GET_OPTICIANS";
export const GET_PATIENTS = "GET_PATIENTS";
export const DELETE_DOCTOR = "DELETE_DOCTOR";
export const DELETE_PATIENT = "DELETE_PATIENT";
export const DELETE_OPTICIAN = "DELETE_OPTICIAN";
export const UPDATEOPTICIANROLE = "UPDATEOPTICIANROLE";
export const GET_NEW_USERS = "GET_NEW_USERS";
export const VERIFY_LICENSE = "VERIFY_LICENSE";
export const DELETE_NEW_USER = "DELETE_NEW_USER";
export const GET_ACTIVE_USERS = "GET_ACTIVE_USERS";
export const GET_DEACTIVE_USERS = "GET_DEACTIVE_USERS";
export const UPDATE_DEACTIVE_USERS = "UPDATE_DEACTIVE_USERS";
export const CREATE_USER = "CREATE_USER";
export const PERMANENT_DELETE_USER = "PERMANENT_DELETE_USER";
